import { render, staticRenderFns } from "./FactFind.vue?vue&type=template&id=edb3dd90&scoped=true&"
import script from "./FactFind.vue?vue&type=script&lang=js&"
export * from "./FactFind.vue?vue&type=script&lang=js&"
import style0 from "./FactFind.vue?vue&type=style&index=0&id=edb3dd90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb3dd90",
  null
  
)

export default component.exports